'use strict';
'use es6';

/**
 * @param  {string}
 * @return {string}
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultPropName = getDefaultPropName;
exports.getOnChangeName = getOnChangeName;
exports.getPropFromDefaultName = getPropFromDefaultName;
function capitalize(str) {
  return str[0].toUpperCase() + str.slice(1);
}

/**
 * @param  {string}
 * @return {string}
 */
function uncapitalize(str) {
  return str[0].toLowerCase() + str.slice(1);
}

/**
 * @param  {string}
 * @return {string}
 */
function getDefaultPropName(field) {
  return 'default' + capitalize(field);
}

/**
 * @param  {string}
 * @return {string}
 */
function getOnChangeName(field) {
  if (field === 'value') {
    return 'onChange';
  }
  return 'on' + capitalize(field) + 'Change';
}

/**
 * @param  {string}
 * @return {string}
 */
function getPropFromDefaultName(defaultProp) {
  if (!defaultProp) {
    return '';
  }

  return uncapitalize(defaultProp.replace('default', ''));
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/core/PropNames.js
// module id = 234
// module chunks = 0 1